export const new_and_improved = {
    label: "New and Improved",
    value: "new_and_improved",
};
export const fan_favorite = {
    label: "Fan Favorite",
    value: "fan_favorite",
};
export const vegetarian = {
    label: "Vegetarian",
    value: "vegetarian",
};
export const none = {
    label: "None",
    value: "none",
};
export const dmbBadgeOptions = [none, new_and_improved, fan_favorite, vegetarian];
